import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import request from "../../../utilities/requests";
import { toast } from "../../../utilities/SnackBarUtils";

const RegistrationDialog = ({ open, close, eventId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [success, setSuccess] = useState(false);

  const handleRegister = async () => {
    const body = { eventId };
    const result = await request("events/register", "post", body);
    if (result.success) {
      setSuccess(true);
    } else if (result.alreadyRegistered) {
      toast.error(t('event.register.alreadyregisterd'));
      close();
    }
  };

  if (success) {
    return (
      <Dialog open={open} onClose={() => close()}>
        <DialogTitle>{t('event.register.success.title')}</DialogTitle>
        <DialogContent>
          <Typography>{t('event.register.success.body')}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => navigate("/profile")}>{t('event.register.gotoprofile')}</Button>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <Dialog open={open} onClose={() => close()}>
      <DialogTitle>{t('event.register.dialog.title')}</DialogTitle>
      <DialogContent>
        <Typography>
          {t('event.register.dialog.body')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => close()}>{t('dialog.cancel.button')}</Button>
        <Button onClick={handleRegister}>{t('event.register.dialog.title')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default RegistrationDialog;
